
export default class SearchResults {
  Results: SearchResult[];
}

export class SearchResult {
  Assets: Asset[];
}

export class Asset {
  AssetID: string;
  Title: string;
  Description: string;
  SubType: string;
}